module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-13.068a2c02.jpg";